import React, { useState, useEffect, useMemo } from 'react';
import $ from 'jquery';
import GoogleMapReact from 'google-map-react';
//import { MarkerIcon } from '@components/icon/icon';
import { connectInfiniteHits } from 'react-instantsearch-core';


import Marker from './resultsmarker';
// import { mapStyles } from "./constants"
import { useStaticQuery, graphql } from 'gatsby';

function MapsInfiniteHits(props) {

  const [mapenable, setMapenable] = useState(false);
  const [render, setRender] = useState(false);

  const [mapmarkers, setMapmarkers] = useState([]);
  const [currentId, setCurrentId] = React.useState("");
  const [hits, setHits] = React.useState([]);
  const [noHits, setNoHits] = React.useState([]);
  const [zoom, setZoom] = React.useState(11);

  const { glstrapi } = useStaticQuery(graphql`
      query MapNoResultPropertiesQuery {
          glstrapi {
              standardProperties: properties(limit: 20, where: { publish: true, department_in: ["residential", "commercial"] }) {
                  id
                  display_address
                  address
                  search_type
                  status
                  slug
                  title
                  department
                  building
                  price
                  images
                  imagetransforms
                  ggfx_results { id content_type transforms src_import_url src_cftle field }
                  floorarea_min
                  floorarea_max
                  floorarea_type
                  crm_negotiator_id
                  introtext
                  extra
                  latitude
                  longitude
              }
              auctionProperties: properties(limit: 20, where: { publish: true, department_in: ["auction_residential", "auction_commercial"], status_in: ["Unsold", "ReferToAuctioneer"] }) {
                  id
                  display_address
                  address
                  search_type
                  status
                  slug
                  title
                  department
                  building
                  price
                  images
                  imagetransforms
                  ggfx_results { id content_type transforms src_import_url src_cftle field }
                  floorarea_min
                  floorarea_max
                  floorarea_type
                  crm_negotiator_id
                  introtext
                  extra
                  latitude
                  longitude
              }
          }
      }
  `)

  const allStandardProps = glstrapi?.standardProperties || [];
  const allAuctionProps = glstrapi?.auctionProperties || [];

  const no_data = useMemo(() => {
    return {
      properties: props.status
        ? allStandardProps.filter(p => p.status === props.status && p.department === props.department)
        : allAuctionProps.filter(p => p.department === props.department)
    };
  }, [allStandardProps, allAuctionProps, props.status, props.department]);

  //console.log("props_hits", props.hits, no_data);


  const [center, setCenter] = React.useState({ lat: 51.5287352, lng: -0.3817853 });

//   if(hits != props.hits) {
//     setRender(false)
//     setHits([])

//     var mapmarkersarr = props.hits && props.hits?.filter(hit => hit._geoloc?.lat);

//     var hits_arra = mapmarkersarr;

//     //console.log("props_hits",hits_arra)
    
//     if (props.hits.length <= 0) {
//       mapmarkersarr.push({ objectID: "noProp", _geoloc:{lat: 51.5287352, lng: -0.3817853 }})
//     } if (mapmarkersarr.length <= 4) {
//       // console.log("xxx1",props.hits[0])
//       mapmarkersarr.push({ objectID: "noProp", _geoloc:{lat: parseFloat(hits_arra[0]?._geoloc?.lat) + 0.008, lng: parseFloat(hits_arra[0]?._geoloc?.lng) + 0.008 }})
//       mapmarkersarr.push({ objectID: "noProp", _geoloc:{lat: parseFloat(hits_arra[0]?._geoloc?.lat) - 0.009, lng: parseFloat(hits_arra[0]?._geoloc?.lng) - 0.009 }})
//     }


//     //setHits(props.hits)

//     // var loc_arr = props.hits.length > 0 ? props.hits : [{ objectID: "noProp", _geoloc:{lat: 51.5287352, lng: -0.3817853 }}]
//     setHits(props.hits)
//     setTimeout(() => {
//       setRender(true)      
//     }, 200);

// }

useEffect(()=>{
  setRender(false)
  setHits(props.hits)
  //setNoHits([{ objectID: "noProp", _geoloc:{lat: 51.5287352, lng: -0.3817853 }}])
  const renderTimer = setTimeout(() => {
    setRender(true)
  }, 200);

  return () => {
    clearTimeout(renderTimer);
  };
},[props.hits])

useEffect(()=>{
  var no_hits = []
  if(props.hits.length === 0){
    no_data?.properties?.length > 0 && no_data?.properties?.map((item => no_hits.push({objectID: item.id, _geoloc:{lat: item.latitude, lng: item.longitude} })))
    const currentNoHits = hits?.filter(hit => hit?._geoloc?.lat).map(hit => `${hit.objectID}:${hit?._geoloc?.lat}:${hit?._geoloc?.lng}`).join('|');
    const nextNoHits = no_hits?.filter(hit => hit?._geoloc?.lat).map(hit => `${hit.objectID}:${hit?._geoloc?.lat}:${hit?._geoloc?.lng}`).join('|');
    if (currentNoHits !== nextNoHits) {
      setHits(no_hits);
    }
    setZoom(9);
  }
},[props.hits, no_data])

useEffect(()=>{
  (hits && hits?.length > 4) ? setZoom(9) : setZoom(9);
},[hits])


  const mygetMapBounds = (map, maps, places) => {
    const bounds = new maps.LatLngBounds();

    places.forEach((place) => {
      bounds.extend(new maps.LatLng(
        place._geoloc?.lat,
        place._geoloc?.lng,
      ));
    });
    return bounds;
  };

  // Re-center map when resizing the window
  const mybindResizeListener = (map, maps, bounds) => {
    maps.event.addDomListenerOnce(map, 'idle', () => {
      maps.event.addDomListener(window, 'resize', () => {
        map.fitBounds(bounds);
      });
    });
  };

  // Fit map to its bounds after the api is loaded
  const myapiHasLoaded = (map, maps, places) => {
    // Get bounds by our places
    const bounds = mygetMapBounds(map, maps, places);
    // Fit map to bounds
    map.fitBounds(bounds);
    // Bind the resize listener
    mybindResizeListener(map, maps, bounds);
  };

  //console.log("hits ==>", zoom, hits);

  return (
    <div id="map" className="map">
      {render &&
      <GoogleMapReact
          bootstrapURLKeys={{ 
            key: `${process.env.GATSBY_MAPS_API_KEY}`
          }}
          options={{ styles: "" }}
          center={center}
          //zoom={hits?.filter(hit => hit?._geoloc?.lat).length > 0 ? zoom : 9}
          zoom={zoom}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => hits?.filter(hit => hit?._geoloc?.lat).length > 0 &&  myapiHasLoaded(map, maps, hits?.filter(hit => hit?._geoloc?.lat))}
      >
        {hits?.length > 0 && (hits?.filter(hit => hit?._geoloc?.lat).map((pnt,ind) => {
          
          if(pnt._geoloc?.lat && pnt._geoloc?.lng){
            if(props.srch_depart === "investment"){
              if(pnt?.status && pnt?.status?.toLowerCase() === "sold" && props.includeSold === true){
                return(<Marker key={ind} lat={pnt._geoloc?.lat} lng={pnt._geoloc?.lng} text={"noProp"} currentId={currentId} setCurrentId={setCurrentId}/>)
              } else{
                return(<Marker key={ind} lat={pnt._geoloc?.lat} lng={pnt._geoloc?.lng} text={pnt.objectID} currentId={currentId} setCurrentId={setCurrentId}/>)
              }
            } else{
              return(<Marker key={ind} lat={pnt._geoloc?.lat} lng={pnt._geoloc?.lng} text={pnt.objectID} currentId={currentId} setCurrentId={setCurrentId}/>)
            }
          }
          
          }
        ))
          // :
          // (noHits?.filter(hit => hit?._geoloc?.lat).map((pnt,ind) => <Marker key={ind} lat={pnt._geoloc?.lat} lng={pnt._geoloc?.lng} text={pnt.objectID} currentId={currentId} setCurrentId={setCurrentId}/>))
        }
      </GoogleMapReact>
      }
    </div>
  );
}

const MapContainer = connectInfiniteHits(MapsInfiniteHits)

export default React.memo(MapContainer);

// export default MapsInfiniteHits;